export const Solutions = {
  Listings: 'listings',
  ReputationManagement: 'reputation-management',
  Insights: 'insights',
};

export const Roles = {
  Administrator: 'administrator',
  Editor: 'editor',
  Observer: 'observer',
  Fuel_Shortage: 'fuel_shortage',
};

export const StationListResponseType = {
  no_stations: 'no_stations',
  stations_without_address: 'stations_without_address',
  stations_with_address: 'stations_with_address',
  full_stations: 'full_stations',
  only_station_ids: 'only_station_ids',
};

// Types of comparison metrics
export const ComparisonMetricTypes = {
  nearbyStations: 'Nearby Stations',
  priorPeriod: 'Prior Period',
  myStations: 'My Stations',
  otherStationList: 'Other Station List',
  brand: 'Brand',
  industry: 'Industry Average',
};

export const RatingScoreLabels = {
  good: 'good',
  average: 'average',
  poor: 'poor',
};

export const PagePaths = {
  StationProfile: '/client/station-profiles/station-profile',
};

export const StationListType = {
  AllStations: 'allstations',
  Shared: 'shared',
  Watched: 'watched',
  Private: 'private',
};

export const SortOrder = {
  newest: 'newest',
  oldest: 'oldest',
};

export const ReviewSentiment = {
  positive: 'positive',
  neutral: 'neutral',
  negative: 'negative',
};

export const ReviewType = {
  starred: 'starred',
  replied: 'replied',
  reported: 'reported',
  written_reviews: 'written',
};
